import React, { useCallback } from 'react';
import { SubmitBar } from '../components/submit-bar';
import { SkillCompletionContent } from '../page-content/skill-completion-content';
import styled from '@emotion/styled';
import { moveOnToNextPage } from '../redux/actions/ui';
import { ConfettiComp } from '../components/confetti-comp';
import '../css/skill-completion.css';
import { SkillCompletionData } from 'its-pages';
import { useAppDispatch } from '../redux/hooks';

interface OwnProps {
  skillCompletionContent: SkillCompletionContent;
}

const CenteredWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  align-self: center;
  justify-self: center;
`;

export const SkillCompletion  = (props: OwnProps) => {
  const dispatch = useAppDispatch();
  const { skillCompletionContent } = props;
  const { currentSkill, nextSkill } =
    skillCompletionContent.pageData as SkillCompletionData;

  const onSubmit = useCallback(() => {
    dispatch(moveOnToNextPage());
  }, [dispatch]);

  return (
    <div className='Problem SkillCompletion'>
      <ConfettiComp numberOfPieces={100} gravity={0.1} />
      <CenteredWrapper>
        <div className='CurrentSkillTitle'>
          {currentSkill.name.toLocaleUpperCase()}
        </div>
        <div className='AllDone'>Competency Completed!</div>
        <div className='GreatJob'>
          Great Job going through the {currentSkill.name.toLocaleLowerCase()}{' '}
          competency. With enough practice you{"'"}ll be better prepared to help
          patients.
        </div>
      </CenteredWrapper>
      <CenteredWrapper>
        <div className='NextSkill'>
          Next up is the {nextSkill.name.toLocaleLowerCase()} skill.
        </div>
      </CenteredWrapper>
      <SubmitBar
        onSubmit={onSubmit}
        disableSubmit={false}
        buttonText={'Next Skill'}
        buttonClass={'SubmitBarButton'}
      />
    </div>
  );
};
